import Requestor from '@/api/Requestor';
import { clientInstance } from '@/api/core';
// 바로고 공지사항
class BarogoNoticeApi extends Requestor {
    /**
     * 리스트 조회
    */
    getItemList(params = {}) {
        return this.get({
            url: '/api/v2/head-quarter-notices',
            params,
        });
    }
    /**
     * 단건 조회
     */
    getItem(id, params) {
        return this.get({
            url: `/api/v2/head-quarter-notices/${id}`,
            params,
        });
    }
}
export const barogoNoticeApi = new BarogoNoticeApi(clientInstance);
